import PropTypes from "prop-types";

export default PropTypes.shape({
  awaiting: PropTypes.arrayOf(
    PropTypes.shape({
      engagementId: PropTypes.number,
      jobId: PropTypes.number,
      name: PropTypes.string,
      company: PropTypes.string,
      respondedAt: PropTypes.string,
      message: PropTypes.string,
      reviewAgentUrl: PropTypes.string,
      acceptUrl: PropTypes.string,
      rejectUrl: PropTypes.string,
      avatar: PropTypes.string,
      starRatingPercent: PropTypes.number,
    })
  ),
  pendingInvitation: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      company: PropTypes.string,
      avatar: PropTypes.string,
      starRatingPercent: PropTypes.number,
      hhScore: PropTypes.number,
      isNew: PropTypes.bool,
      psl: PropTypes.bool,
      id: PropTypes.number,
      agentUrl: PropTypes.string,
      activeSince: PropTypes.string,
    })
  ),
  engaged: PropTypes.arrayOf(
    PropTypes.shape({
      engagementId: PropTypes.number,
      name: PropTypes.string,
      agentLink: PropTypes.string,
      company: PropTypes.string,
      activeSince: PropTypes.string,
      psl: PropTypes.bool,
      disengageUrl: PropTypes.string,
      avatar: PropTypes.string,
      starRatingPercent: PropTypes.number,
    })
  ),
  disengaged: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      agentLink: PropTypes.string,
      company: PropTypes.string,
      activeSince: PropTypes.string,
      avatar: PropTypes.string,
      starRatingPercent: PropTypes.number,
    })
  ),
});
